import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Goals() {
    return (
        <OnboardingBody
            title='Define goals to collect leads, bookings and forms'
            statusText='New: AI Chatbot'
        >
            <p>
                The best way to use the sales chatbot is to answer the questions your visitors have,
                while steering them toward becoming a lead: the bot will seamlessly collect bookings
                with {/* @ts-expect-error */}
                <Link to='/sales/scheduler' as={RouterLink} newTab={true}>
                    Nutshell Scheduler
                </Link>
                , collect {/* @ts-expect-error */}
                <Link to='/marketing/forms' as={RouterLink} newTab={true}>
                    Nutshell Forms
                </Link>
                , or let your visitors chat live with one of your own team.
            </p>
        </OnboardingBody>
    );
}
